import React from 'react'
import SelectBase, {Props as SelectProps} from 'react-select'
import {
  CustomClearIndicator,
  CustomDropdownIndicator,
  CustomLoadingIndicator,
  customStyles,
  customTheme
} from './selectCommonComponents'

export type Props<OptionType, IsMulti extends boolean> = SelectProps<
  OptionType,
  IsMulti
> & {
  error?: string
}

function Select<OptionType, IsMulti extends boolean>({
  styles,
  theme,
  components,
  ...props
}: Props<OptionType, IsMulti>) {
  return (
    <>
      <SelectBase<OptionType, IsMulti>
        styles={{...customStyles, ...styles}}
        theme={defaultTheme => ({...defaultTheme, ...customTheme, ...theme})}
        components={{
          ...components,
          IndicatorSeparator: null,
          ClearIndicator: CustomClearIndicator,
          DropdownIndicator: CustomDropdownIndicator,
          LoadingIndicator: CustomLoadingIndicator
        }}
        isClearable
        {...props}
      />
    </>
  )
}

export default Select
